if (!customElements.get('myrevora-product-presentation')) {
  customElements.define('myrevora-product-presentation', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        const title = this.productInfo.querySelector('.product__title h1');
        if (title && !title.querySelector('bdi')) {
          const match = title.textContent.match(/^([A-Za-z0-9][A-Za-z0-9 -]*)(\s*\|[\s\S]*)$/);
          if (match) {
            const brand = document.createElement('bdi');
            brand.dir = 'ltr';
            brand.textContent = match[1].trimEnd();
            title.replaceChildren(brand, document.createTextNode(` ${match[2].trimStart()}`));
          }
        }
        this.productInfo.querySelectorAll('.product__text').forEach((text) => {
          if (!text.textContent.trimStart().startsWith('✓') || text.classList.contains('myrevora-benefit')) return;
          const content = text.textContent.trimStart().slice(1).trimStart();
          const check = document.createElement('span');
          check.className = 'myrevora-benefit__check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          const label = document.createElement('span');
          let offset = 0;
          for (const match of content.matchAll(/\d+(?:\.\d+)?\s+[A-Za-z]+/g)) {
            label.append(document.createTextNode(content.slice(offset, match.index)));
            const measurement = document.createElement('bdi');
            measurement.dir = 'ltr';
            measurement.textContent = match[0];
            label.append(measurement);
            offset = match.index + match[0].length;
          }
          label.append(document.createTextNode(content.slice(offset)));
          text.replaceChildren(check, label);
          text.classList.add('myrevora-benefit');
        });
        this.update({ price: Number(this.dataset.price), compare_at_price: Number(this.dataset.comparePrice) });
        this.unsubscribe?.();
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) === this.productInfo.dataset.section) this.update(data.variant);
        });
      });
    }

    update(variant) {
      const price = this.productInfo.querySelector('[id^="price-"] .price');
      if (!price) return;
      price.querySelector('.myrevora-discount')?.remove();
      const current = variant?.price;
      const compare = variant?.compare_at_price;
      if (!Number.isFinite(current) || !Number.isFinite(compare) || current < 0 || compare <= current) return;
      const percentage = Math.round((compare - current) * 100 / compare);
      if (percentage < 1) return;
      const badge = document.createElement('span');
      badge.className = 'myrevora-discount';
      badge.textContent = `${percentage}% הנחה`;
      price.append(badge);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.unsubscribe?.();
    }
  });
}
